<input
  #subscriberLogoFileInput
  id="subscriberLogoFileInput"
  class="d-none"
  type="file"
  accept="image/*"
  (change)="handleFileInput($event.target)"
/>
<div class="p-2 p-lg-4 d-flex flex-wrap row-gap-2 column-gap-5">
  <div
    id="profile-card"
    class="d-flex flex-column align-items-center align-items-lg-start gap-4 flex-grow-1"
  >
    <div
      id="top-section"
      class="d-flex flex-row gap-0 align-items-center align-items-lg-start flex-column"
    >
      @if (subscriberLogoUrl) {
        <div id="profile-picture" class="company-logo-container mb-3 mb-lg-2">
          <img id="companyLogo" [src]="subscriberLogoUrl" alt="Company Logo" />
          <div class="edit-logo-button" (click)="openCamPopup()">
            <i class="fa-solid fa-pen"></i>
          </div>
        </div>
      }

      <div id="name-contact-details">
        <div class="fs-1 flex-grow-1 text-break">
          {{ companyDetails?.name }}
        </div>
        @if (companyDetails?.abn) {
          <div class="mb-2 fs-4">
            {{ companyDetails?.abn }}
          </div>
        }
        <div class="mb-2 text-break d-flex gap-2 align-items-center small">
          <i class="fa-solid fa-location-dot"></i>
          {{ companyDetails?.address?.full_address }}
        </div>

        <div class="mb-2 text-break d-flex gap-2 align-items-center small">
          <i class="fa-solid fa-envelope"></i> {{ companyDetails?.email }}
        </div>
        @if (companyDetails?.phone) {
          <div class="mb-2">
            <i class="fa-solid fa-phone"></i> {{ companyDetails?.phone }}
          </div>
        }
      </div>
    </div>

    <div id="buttons">
      <div
        class="d-flex column-gap-2 row-gap-4 gap-lg-2 flex-wrap justify-content-end"
      >
        <div
          class="hover border small p-1 px-3 bg-primary text-white rounded fw-semibold"
          role="button"
          (click)="openTemplate(companyDialog)"
        >
          Edit Details
        </div>
        @if (!subscriberLogoUrl) {
          <div
            id="companyLogo"
            class="hover border small p-1 px-3 bg-warning text-dark rounded fw-semibold"
            role="button"
            (click)="openCamPopup()"
          >
            Upload Company Logo
          </div>
        }

        @if (isAdmin) {
          <div
            class="hover border small p-1 px-2 bg-secondary border-secondary rounded fw-semibold d-flex align-items-center text-white"
            role="button"
            (click)="
              openTemplate(addressLookupRegionSelectionTemplate, 'address')
            "
          >
            Region Settings <i class="fa-solid fa-earth-oceania ms-3"></i>
          </div>
        }
      </div>
    </div>

    <div id="bottom-section">
      @if ((subscriberSettingsInfo | misc: "getDictKeys")?.length) {
        <dl>
          <dt>Subscription Options</dt>
          <div class="d-flex flex-column gap-4 my-2">
            <div id="shift_acceptance">
              <label for="shiftAcceptance">
                <input
                  (change)="
                    subscriberSettingsInfo.shift_auto_accept =
                      !subscriberSettingsInfo?.shift_auto_accept;
                    updateSubscriberAccountSettings()
                  "
                  [checked]="!subscriberSettingsInfo?.shift_auto_accept"
                  class="form-check-input"
                  type="checkbox"
                  id="shiftAcceptance"
                />
                Shift Acceptance
                <span
                  class="ms-2"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="Guards must accept/decline shifts assigned to them"
                >
                  <i class="fa-solid fa-circle-info text-secondary"></i>
                </span>
              </label>
            </div>
            <div id="enhanced_security">
              <label for="enhanceSecurity">
                <input
                  (change)="
                    toggleSubscriberSettings($event, 'enhance_security')
                  "
                  [checked]="subscriberSettingsInfo?.enhance_security"
                  class="form-check-input"
                  type="checkbox"
                  id="enhanceSecurity"
                />
                Use Enhanced Security
                <span
                  class="ms-2"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="Signing on to new devices and browsers requires the user to enter a OTP."
                >
                  <i class="fa-solid fa-circle-info text-secondary"></i>
                </span>
              </label>
            </div>
            <div id="facial_recognition">
              <label for="clockInSelfie">
                <input
                  (change)="
                    toggleSubscriberSettings($event, 'clock_in_out_selfie')
                  "
                  [checked]="subscriberSettingsInfo?.clock_in_out_selfie"
                  class="form-check-input"
                  type="checkbox"
                  id="clockInSelfie"
                />
                Use Facial Recognition during Clock In / Out
                <span
                  class="ms-2"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="Users on mobile devices must take a photo of their face when clocking in and out."
                >
                  <i class="fa-solid fa-circle-info text-secondary"></i>
                </span>
              </label>
            </div>

            <div class="accordion accordion-flush" id="accordionFlushExample">
              <div class="accordion-item">
                <div class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                  >
                    Scheduled Patrol Tasks Max. Distance Threshold: &nbsp;
                    <span class="fw-semibold ms-1 me-2">
                      {{
                        subscriberSettingsInfo?.runsheet_site_task_completion_range
                      }}m
                    </span>
                  </button>
                </div>
                <div
                  id="flush-collapseOne"
                  class="accordion-collapse collapse"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div class="accordion-body">
                    <div class="mb-3">
                      The maximum distance from the location (if a site has been
                      defined) a task can be completed in scheduled patrols.
                    </div>

                    <div class="form-floating">
                      <select
                        id="runSheetTolerance"
                        class="form-select w-100"
                        [ngModel]="
                          subscriberSettingsInfo?.runsheet_site_task_completion_range
                        "
                        (ngModelChange)="
                          updateSettingValue(
                            $event,
                            'runsheet_site_task_completion_range'
                          )
                        "
                      >
                        @for (
                          value of [100, 250, 500, 750, 1000];
                          track value
                        ) {
                          <option [value]="value">
                            {{ value }}
                          </option>
                        }
                      </select>
                      <label for="runSheetTolerance">Metres</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <div class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                    aria-expanded="false"
                    aria-controls="flush-collapseTwo"
                  >
                    Alarm Response Pick Up Time: &nbsp;
                    <span class="fw-semibold"
                      >{{
                        subscriberSettingsInfo?.job_stale_after_creation_alert
                      }}
                      minutes</span
                    >
                  </button>
                </div>
                <div
                  id="flush-collapseTwo"
                  class="accordion-collapse collapse"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div class="accordion-body">
                    <div class="mb-3">
                      Send notifcations to managers and dispatchers for alarm
                      responses that have not been updated with an ETA to site
                      after this amount of time has passed.
                    </div>

                    <div class="form-floating">
                      <select
                        id="responseStaleAlert"
                        class="form-select w-100"
                        [ngModel]="
                          subscriberSettingsInfo?.job_stale_after_creation_alert
                        "
                        (ngModelChange)="
                          updateSettingValue(
                            $event,
                            'job_stale_after_creation_alert'
                          )
                        "
                      >
                        @for (value of [10, 15, 30, 45, 60]; track value) {
                          <option [value]="value">
                            {{ value }}
                          </option>
                        }
                      </select>
                      <label for="responseStaleAlert">Minutes</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <gtapp-pre-safety-prompts></gtapp-pre-safety-prompts>
            </div>
          </div>
        </dl>
      }
    </div>
  </div>

  <div>
    <gtapp-identification showFrom="companyProfilePage"></gtapp-identification>
  </div>
</div>

@if (isAdmin && largeView) {
  <div class="mb-5"></div>
  <gtapp-user-update-log eventType="subscriber"> </gtapp-user-update-log>
}

<ng-template #companyDialog let-cpRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Company Details
      <span
        class="float-end"
        (click)="companyDialogueStep = 1; cpRef.close('close')"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <form [formGroup]="companyForm" gtappFormEnterAction>
      <div class="d-flex flex-column gap-2">
        @if (companyDialogueStep === 1) {
          @if (companyDetails?.name) {
            <div class="form-floating">
              <input
                class="form-control"
                type="text"
                formControlName="name"
                placeholder="Company Name"
                [class.is-invalid]="
                  companyForm.controls['name'].invalid &&
                  companyForm.controls['name'].touched
                "
              />
              <label for="name">Company Name</label>
            </div>
          }
          @if (
            companyDetails?.address?.country_name?.toLowerCase() == "australia"
          ) {
            <div class="form-floating">
              <input
                class="form-control"
                type="tel"
                inputmode="numeric"
                pattern="[0-9]*"
                formControlName="abn"
                placeholder="ABN"
                minlength="11"
                maxlength="11"
                [class.is-invalid]="companyForm.controls['abn'].invalid"
              />
              <label for="name">ABN</label>
            </div>
          }
          <div class="form-floating">
            <input
              class="form-control"
              type="text"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              formControlName="email"
              placeholder="Email"
              placeholder="ABN"
              [class.is-invalid]="
                companyForm.controls['email'].invalid &&
                companyForm.controls['email'].touched
              "
            />
            <label for="email">Email</label>
          </div>
          <div class="form-floating">
            <input
              class="form-control"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              minlength="7"
              maxlength="10"
              formControlName="phone"
              placeholder="Telephone"
              [class.is-invalid]="
                companyForm.controls['phone'].invalid &&
                companyForm.controls['phone'].touched
              "
            />
            <label for="phone">Telephone</label>
          </div>
          <div class="row row-cols-2">
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-secondary w-100"
                (click)="companyDialogueStep = 1; cpRef.close('close')"
              >
                Cancel
              </button>
            </div>
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-outline-primary w-100"
                [disabled]="
                  companyForm.controls['name'].invalid ||
                  companyForm.controls['abn'].invalid ||
                  companyForm.controls['email'].invalid ||
                  companyForm.controls['phone'].invalid
                "
                (click)="companyDialogueStep = 2"
              >
                Next
              </button>
            </div>
          </div>
        }
        @if (companyDialogueStep === 2) {
          <gtapp-address-lookup
            [addressForm]="companyForm"
            showLookupFrom="subscriberAddress"
          >
          </gtapp-address-lookup>
          <div class="row row-cols-2 gy-2">
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-dark w-100"
                (click)="companyDialogueStep = 1"
              >
                Back
              </button>
            </div>
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-primary w-100"
                id="submitbtn"
                [disabled]="!companyForm.valid"
                (click)="updateData(); cpRef.close(); companyDialogueStep = 1"
              >
                Submit
              </button>
            </div>
          </div>
        }
      </div>
    </form>
  </div>
</ng-template>

<ng-template #smtpConfigTemplate let-smtpConfigTemplate="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      SMTP Configuration
      <span class="float-end" (click)="smtpConfigTemplate.close('close')">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <form [formGroup]="smtpConfigForm">
      <div class="row row-cols-1 mb-4">
        <div class="form-floating">
          <input
            class="form-control"
            type="text"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            formControlName="smtp_host"
            placeholder="Host"
          />
          <label>Host</label>
        </div>
        <div
          class="d-flex align-items-center py-2 px-5 justify-content-between"
        >
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="tlsOption"
              formControlName="protocol"
              value="tls"
              name="protocol"
              (change)="changeSLayer('tls')"
            />
            <label class="form-check-label" for="tlsOption"> TLS </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="sslOption"
              formControlName="protocol"
              value="ssl"
              name="protocol"
              (change)="changeSLayer('ssl')"
            />
            <label class="form-check-label" for="sslOption"> SSL </label>
          </div>
        </div>
        <div class="form-floating">
          <input
            class="form-control"
            type="tel"
            inputmode="numeric"
            pattern="[0-9]*"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            formControlName="smtp_port"
            placeholder="Port"
          />
          <label>Port</label>
        </div>
        <div class="form-floating">
          <input
            class="form-control"
            type="email"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            formControlName="smtp_email"
            placeholder="Email"
          />
          <label for="email">Email</label>
        </div>
        <div class="form-floating">
          <input
            class="form-control"
            type="password"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            formControlName="smtp_password"
            placeholder="Password"
          />
          <label>Password</label>
        </div>
      </div>
    </form>
    @if (smtpConfigForm.valid && !smtpCorrectlyConfigured) {
      @if (smtpErrorMessage) {
        <div class="alert alert-danger mb-2">{{ smtpErrorMessage }}</div>
      }
      <div class="row row-cols-2 mb-4">
        <div class="form-floating">
          <input
            class="form-control"
            type="email"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            placeholder="Test Email Address"
            [(ngModel)]="sampleEmailAddress"
          />
          <label for="email">Test Email Address</label>
        </div>
        <div>
          <button
            type="button"
            class="btn btn-lg btn-success w-100"
            id="submitbtn"
            [disabled]="!sampleEmailAddress"
            (click)="sendSampleEmail()"
          >
            Send Sample Email
          </button>
        </div>
      </div>
    }
    <div class="row row-cols-2 gy-2">
      <div class="col">
        <button
          type="button"
          class="btn btn-lg btn-dark w-100"
          (click)="smtpConfigTemplate.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          type="button"
          class="btn btn-lg btn-primary w-100"
          id="submitbtn"
          [disabled]="!smtpCorrectlyConfigured"
          (click)="smtpConfigTemplate.close(); configureSMTP()"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #addressLookupRegionSelectionTemplate
  let-addressLookupRegionSelectionTemplateRef="dialogRef"
>
  <div class="card dialog-box p-2">
    <div class="card-header">
      Region Settings
      <span
        class="float-end"
        (click)="addressLookupRegionSelectionTemplateRef.close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="px-lg-5">
      <div>Include the following countries when searching addresses</div>
      <div class="d-flex flex-column gap-4 mb-5 p-3">
        @for (region of addressLookupDataList; track $index) {
          <div class="d-flex align-items-center gap-3 ps-2">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="region?.selected"
              (change)="updateAddressLookupSelection(region)"
            />
            <label for="">{{ region?.label }}</label>
          </div>
        }
      </div>
    </div>
    <div class="row row-cols-2">
      <div class="col">
        <button
          (click)="addressLookupRegionSelectionTemplateRef.close()"
          class="btn btn-lg btn-secondary w-100"
          type="button"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          (click)="
            addressLookupRegionSelectionTemplateRef.close();
            updateAddressLookupRegions()
          "
          class="btn btn-lg btn-primary w-100"
          [disabled]="!selectedRegionsForAddressLookup.size"
          type="button"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
